import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
export class GlobalErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        // TODO: Implement error reporting logic here
        console.error('Error caught by boundary:', error, errorInfo);
        // Placeholder for error reporting service
        // this.reportError(error, errorInfo);
    }
    // reportError(error: Error, errorInfo: ErrorInfo) {
    //   // Fill out error reporting implementation here
    // }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsxs("div", { style: { padding: '20px', textAlign: 'center' }, children: [_jsx("h1", { children: "Something went wrong" }), _jsx("p", { children: "We're sorry for the inconvenience. Please try refreshing the page." }), this.state.error && (_jsxs("details", { style: { marginTop: '20px', textAlign: 'left' }, children: [_jsx("summary", { children: "Error details" }), _jsx("pre", { children: this.state.error.toString() })] }))] }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=GlobalErrorBoundary.js.map